<div class="layout-dashboard">
    <div class="grid">
        <div class="col-12 xl:col-12">
            <div class="card">
                <div
                    class="flex w-full justify-content-between align-items-center"
                >
                    <h4>{{'INSURANCE_PROVIDERS' | translate}}</h4>
                    <button
                        type="button"
                        pButton
                        class="p-button p-button-primary"
                        icon="pi pi-plus-circle"
                        (click)="addInsuranceProviderClicked()"
                        [label]="'ADD_INSURANCE_PROVIDER' | translate"
                    ></button>
                </div>
                <div class="spacer"></div>
                <div>
                    <div class="providers-container my-4">
                        <app-provider-card
                            *ngFor="let provider of insuranceProviders"
                            [provider]="provider"
                        ></app-provider-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
